import i18n from "../../i18n/index";
export default {
  data() {
    return {
      rowsPerPageItems: [5, 10, 15, 25],
      headers: [
        {
          text: i18n.t("headers.state"),
          sortable: false,
          value: "resource",
        },
        {
          text: i18n.t("headers.city"),
          value: "name",
          sortable: true,
        },
        {
          text: i18n.t("headers.action"),
          sortable: false,
          value: "action",
        },
      ],
    };
  },
  props: {
    deletebranch: {
      type: Function,
      default: () => {},
    },
    branchCities: { type: Array, default: [] },
  },
  watch: {},
  methods: {
    deleteCity(city) {
      const index = this.branchCities.findIndex((c) => c.id === city.id);
      this.deletebranch(city);
      this.branchCities.splice(index, 1);
      this.$emit("pushData", this.branchCities);
    },
    onRowClick(item) {
      this.$emit("row-click", item);
    },
  },
};
